import { useState } from "react";
import logo from "../assets/logo.png";

const mainNav = [
  { label: "Home", path: "/" },
  { label: "About us", path: "/about" },
  { label: "Questionnaire", path: "/questionnaire" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
  { label: "ERIC NUR", path: "/eric-nur" },
];

const defaultSettings = {
  logo_image_url: "",
  logo_alt_text: "Trophy NNN Assets logo",
  logo_title: "Trophy NNN Assets",
  logo_subtitle: "American Realty Network LLC",
  primary_phone: "561-702-3795",
  primary_cta_label: "Call or Text",
  primary_cta_link: "/contact",
};

function NavBar({ currentPath, onNavigate, siteSettings = defaultSettings, navigationItems = mainNav }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navItems = Array.isArray(navigationItems) && navigationItems.length ? navigationItems : mainNav;
  const settings = { ...defaultSettings, ...(siteSettings || {}) };

  const goTo = (path) => {
    setMobileOpen(false);
    onNavigate(path);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-obsidian-700 bg-obsidian-950 text-cream-50">
      <div className="section-wrap py-3">
        <div className="flex items-center justify-between gap-3">
          <button
            className="flex items-center gap-3 text-left"
            onClick={() => goTo("/")}
            aria-label="Go to homepage"
          >
            <img
              src={settings.logo_image_url || logo}
              alt={settings.logo_alt_text}
              className="h-12 w-12 object-contain sm:h-14 sm:w-14"
            />
            <div>
              <p className="font-serif text-2xl leading-none text-cream-50 sm:text-3xl">{settings.logo_title}</p>
              <p className="mt-1 text-[10px] uppercase tracking-[0.22em] text-cream-200/80 sm:text-xs">
                {settings.logo_subtitle}
              </p>
            </div>
          </button>

          <div className="hidden items-center gap-5 lg:flex">
            <nav className="flex items-center gap-1 whitespace-nowrap xl:gap-2">
              {navItems.filter((item) => item.is_visible !== false).map((item) => {
                const active = item.path ? currentPath === item.path : false;

                return (
                  <button
                    key={item.path}
                    className={`rounded-lg px-3 py-1.5 text-sm font-semibold transition ${
                      active ? "bg-obsidian-700 text-cream-50" : "text-cream-100 hover:bg-obsidian-800"
                    }`}
                    onClick={() => goTo(item.path)}
                  >
                    {item.label}
                  </button>
                );
              })}
            </nav>

            <div className="flex flex-col items-center">
              <button
                className="rounded-xl bg-gold-500 px-4 py-2 text-sm font-semibold text-obsidian-950 hover:bg-cream-300"
                onClick={() => goTo(settings.primary_cta_link || "/contact")}
              >
                {settings.primary_cta_label}
              </button>
              <p className="mt-1 text-L font-semibold text-cream-200">{settings.primary_phone}</p>
            </div>
          </div>

          <button
            className="rounded-xl border border-obsidian-500 px-3 py-2 text-sm font-semibold lg:hidden"
            onClick={() => setMobileOpen((prev) => !prev)}
          >
            Menu
          </button>
        </div>

        {mobileOpen ? (
          <div className="mt-4 grid gap-2 rounded-2xl border border-obsidian-700 bg-obsidian-900 p-4 lg:hidden">
            {navItems.filter((item) => item.is_visible !== false).map((item) => {
              return (
                <button
                  key={item.path}
                  className="rounded-lg border border-obsidian-700 px-3 py-2 text-left text-sm font-semibold text-cream-50"
                  onClick={() => goTo(item.path)}
                >
                  {item.label}
                </button>
              );
            })}
          </div>
        ) : null}
      </div>
    </header>
  );
}

export default NavBar;
